import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getTeamService = (request?: t.GetTeamRequestType) => {
  log.info("getTeamService Request: " + JSON.stringify(request));
  let GET_TEAM_API_ENDPOINT = `${apiCoreEndpoint}/account/team`;
  const accountName =
    request && request.params ? request.params.account_name : undefined;
  const teamName =
    request && request.params ? request.params.team_name : undefined;
  if (request?.id) {
    GET_TEAM_API_ENDPOINT = `/${request.id}/`;
  } else if (accountName) {
    GET_TEAM_API_ENDPOINT += `?account=${accountName}`;
    if (teamName) {
      GET_TEAM_API_ENDPOINT += `&team=${teamName}`;
    }
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_TEAM_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_TEAM_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getTeamsService = (request?: t.GetTeamsRequestType) => {
  log.info("getTeamsService Request: " + JSON.stringify(request));
  let GET_TEAMS_API_ENDPOINT = `${apiCoreEndpoint}/account/team`;
  const accountName =
    request && request.params ? request.params.account_name : null;
  if (accountName) {
    log.info("Filtering by Account: " + accountName);
    GET_TEAMS_API_ENDPOINT += `?account=${accountName}`;
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_TEAMS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_TEAMS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const addTeamService = (request: t.CreateTeamRequestType) => {
  log.info("addTeamService Request: " + JSON.stringify(request));
  const ADD_TEAM_API_ENDPOINT = `${apiCoreEndpoint}/account/team`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(ADD_TEAM_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, ADD_TEAM_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const modifyTeamService = (request: t.ModifyTeamRequestType) => {
  log.info("modifyTeamService Request: " + JSON.stringify(request));
  const teamId = request.id;
  const MODIFY_TEAM_API_ENDPOINT = `${apiCoreEndpoint}/account/team/${teamId}`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(MODIFY_TEAM_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, MODIFY_TEAM_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteTeamService = (request: t.DeleteTeamRequestType) => {
  log.info("deleteTeamService Request: " + JSON.stringify(request));
  const teamId = request.id;
  const DELETE_TEAM_API_ENDPOINT = `${apiCoreEndpoint}/account/team/${teamId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_TEAM_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DELETE_TEAM_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getTeamUsersService = (request?: t.GetTeamUsersRequestType) => {
  log.info("getTeamUsersService Request: " + JSON.stringify(request));
  let GET_TEAM_USERS_API_ENDPOINT: string;
  const accountName =
    request && request.params ? request.params.account_name : undefined;
  const teamName =
    request && request.params ? request.params.team_name : undefined;
  log.info("Getting Team Users...");
  if (accountName) {
    log.info(`Filtering by Account = ${accountName}...`);
    if (teamName) {
      log.info(`Filtering by Team = ${teamName}...`);
      GET_TEAM_USERS_API_ENDPOINT = `${apiCoreEndpoint}/account/team/user?account=${accountName}&team=${teamName}`;
    } else {
      GET_TEAM_USERS_API_ENDPOINT = `${apiCoreEndpoint}/account/team/user?account=${accountName}`;
    }
  } else {
    GET_TEAM_USERS_API_ENDPOINT = `${apiCoreEndpoint}/account/team/user`;
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_TEAM_USERS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_TEAM_USERS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const addTeamUserService = (request: t.AddTeamUserRequestType) => {
  log.info("addTeamUserService Request: " + JSON.stringify(request));
  const ADD_TEAM_USER_API_ENDPOINT = `${apiCoreEndpoint}/account/team/user`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(ADD_TEAM_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, ADD_TEAM_USER_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteTeamUserService = (request: t.RemoveTeamUserRequestType) => {
  log.info("deleteTeamUserService Request: " + JSON.stringify(request));
  const teamUserId = request.id;
  const DELETE_TEAM_USER_API_ENDPOINT = `${apiCoreEndpoint}/account/team/user/${teamUserId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_TEAM_USER_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DELETE_TEAM_USER_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
